import { render, staticRenderFns } from "./YoutubeEmbed.vue?vue&type=template&id=af3c651c&"
import script from "./YoutubeEmbed.vue?vue&type=script&lang=js&"
export * from "./YoutubeEmbed.vue?vue&type=script&lang=js&"
import style0 from "./YoutubeEmbed.vue?vue&type=style&index=0&id=af3c651c&prod&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports